import { render } from "./PageVisualizarAgenda.vue?vue&type=template&id=fb83da84"
import script from "./PageVisualizarAgenda.vue?vue&type=script&lang=js"
export * from "./PageVisualizarAgenda.vue?vue&type=script&lang=js"

import "./PageVisualizarAgenda.vue?vue&type=style&index=0&id=fb83da84&lang=css"
/* custom blocks */
import block0 from "./PageVisualizarAgenda.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__